import { render, staticRenderFns } from "./table-chengpin.vue?vue&type=template&id=c1d9dc38&scoped=true"
import script from "./table-chengpin.vue?vue&type=script&lang=js"
export * from "./table-chengpin.vue?vue&type=script&lang=js"
import style0 from "./table-chengpin.vue?vue&type=style&index=0&id=c1d9dc38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d9dc38",
  null
  
)

export default component.exports